import type { ICampaignType, IVariantType } from '~/modules/campaign/types';

import { MobileVariantHeader } from './MobileVariantHeader';
import { MOBILE_VARIANT_GRADIENT_BG } from '../constants';
import { useWindowSize } from '~/presentation/common';
import { CardGridWrapper } from './CardGridWrapper';
import { BlockStack, Box } from '@shopify/polaris';
import { BOX_PADDING } from '~/modules/campaign';
import { GBoxCard } from '~/presentation/ui';

export interface EmptyVariantSetupCardProps {
  campaignType: ICampaignType;
  variants: [IVariantType, IVariantType];
  renderButton: (variantType: IVariantType) => React.ReactNode;
}

export const EmptyVariantSetupCard: React.FC<EmptyVariantSetupCardProps> = ({
  campaignType,
  variants,
  renderButton,
}) => {
  const { isMobileView } = useWindowSize();

  if (isMobileView) {
    return (
      <div className="bg-white border border-solid border-[var(--p-color-border)] rounded-lg overflow-hidden">
        <div style={MOBILE_VARIANT_GRADIENT_BG}>
          {variants.map((variantType) => (
            <div key={variantType} className="p-4">
              <MobileVariantHeader variantType={variantType} campaignType={campaignType} />
              <Box paddingBlockStart="300">
                <Box
                  padding="800"
                  borderRadius="200"
                  borderColor="border-tertiary"
                  borderWidth="025"
                  borderStyle="dashed"
                  background="bg-fill"
                >
                  <BlockStack align="center" inlineAlign="center">
                    {renderButton(variantType)}
                  </BlockStack>
                </Box>
              </Box>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <GBoxCard>
      <CardGridWrapper
        boxProps={{}}
        columns={variants.map((variantType) => ({
          children: (
            <Box
              {...(variantType === variants[0] && { paddingInlineEnd: BOX_PADDING['padding'] })}
              {...(variantType === variants[1] && { paddingInlineStart: BOX_PADDING['padding'] })}
            >
              <Box
                padding="800"
                borderRadius="200"
                borderColor="border-tertiary"
                borderWidth="025"
                borderStyle="dashed"
              >
                <BlockStack align="center" inlineAlign="center">
                  {renderButton(variantType)}
                </BlockStack>
              </Box>
            </Box>
          ),
        }))}
      />
    </GBoxCard>
  );
};
